import { useContext } from 'react'
import { ConciergeContext } from './useConcierge'

export function useWisdomId(): string {
  const { concierge } = useContext(ConciergeContext)
  // Add more wisdomId contexts here as needed

  // If multiple are set, throw error
  // throw new Error('multiple wisdomIds found. useWisdomId must be used within a single provider.')

  const wisdomId = concierge.wisdomId // ?? foo.wisdomId ?? bar.wisdomId
  if (!wisdomId) {
    throw new Error('useWisdomId must be used within a *Provider')
  }
  return wisdomId
}
